__turbopack_context__.v({
  "burger": "TWKW1a_burger",
  "root": "TWKW1a_root",
});
